import React, { useState, useEffect } from "react";

const QtyCountFabric = ({
  qty: initialQty = 1,
  setQty: externalSetQty,
  minQty = 1,
  maxQty = 10,
  steps = 1,
  isReadOnly = true,
  disabled = false,
  pageLanguage,
  NumberToPersianWord,
  handleIncrement,
  handleDecrement,
  handleInputChange,
}) => {
  const [internalQty, setInternalQty] = useState(initialQty);

  useEffect(() => {
    setInternalQty(initialQty);
  }, [initialQty]);

  const roundQty = (value) => Math.round(value * 100) / 100;

  const internalHandleIncrement = () => {
    if (disabled) return;
    if (internalQty < maxQty) {
      const newQty = roundQty(Math.min(internalQty + steps, maxQty));
      setInternalQty(newQty);
      if (externalSetQty) externalSetQty(newQty);
      if (handleIncrement) handleIncrement(steps);
    }
  };

  const internalHandleDecrement = () => {
    if (disabled) return;
    if (internalQty > minQty) {
      const newQty = roundQty(Math.max(internalQty - steps, minQty));
      setInternalQty(newQty);
      if (externalSetQty) externalSetQty(newQty);
      if (handleDecrement) handleDecrement(parseFloat(0 - steps));
    }
  };

  const internalHandleInputChange = (e) => {
    if (disabled) return;
    let value = NumberToPersianWord.convertPeToEn(e.target.value);
    value = parseFloat(value);

    if (isNaN(value)) {
      return;
    }

    if (value < minQty) {
      value = minQty;
    } else if (value > maxQty) {
      value = maxQty;
    }

    value = roundQty(value);
    setInternalQty(value);
    if (externalSetQty) externalSetQty(value);
    if (handleInputChange) handleInputChange(value);
  };

  const formatQuantity = () => {
    return pageLanguage === "fa"
      ? NumberToPersianWord.convertEnToPe(`${internalQty}`)
      : internalQty;
  };

  return (
    <div className="basket_item_qty_numbers">
      <button
        type="button"
        className="basket_qty_minus"
        onClick={internalHandleDecrement}
        disabled={disabled || internalQty <= minQty}
      >
        <img
          src={require("../Images/public/minus.svg").default}
          alt=""
          className="qty_math_icon img-fluid"
        />
      </button>
      <input
        type="text"
        className="basket_qty_num"
        value={formatQuantity()}
        onChange={isReadOnly || disabled ? null : internalHandleInputChange}
        readOnly={isReadOnly || disabled}
      />
      <button
        type="button"
        className="basket_qty_plus"
        onClick={internalHandleIncrement}
        disabled={disabled || internalQty >= maxQty}
      >
        <img
          src={require("../Images/public/plus.svg").default}
          alt=""
          className="qty_math_icon img-fluid"
        />
      </button>
    </div>
  );
};

export default QtyCountFabric;
